import { v4 as uuidv4 } from 'uuid';
import ikun from '@/assets/images/man.png';
export const gangweiTemplateArr = [
  // 1、行政专员-简历模板
  {
    postTitle: '行政专员-简历模板',
    title: '行政专员简历',
    id: 1,
    showTags: ['行政专员'], 
    styleType: 'normal1Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_zbNgBYTU17443791617611897.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '行政专员',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '10k-20k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '工作年限',
          basicVal: '1 - 3年',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: 'lover@163.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2019/09/01',
        toDate: '2023/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX大学',
        major: 'XXXX专业',
        content: '**基础会计学、货币银行学、统计学、经济法概论、财务会计学、管理学原理、组织行为学、市场营销学、国际贸易理论、国际贸易实务、人力资源开发与管理、财务管理学、企业经营战略概论、质量管理学、西方经济学等等**',
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/10/11',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: '公司甲',
        major: '行政专员',
        content: `•负责中心简单财务管理，资产管控；\n
•负责公司总部的来访客户接待工作，负责引导和介绍公司的分布情况；\n
•负责中心的行政事务，公司班车管理、负责建立员工归属感及前台管理；\n
•负责招聘工作，确保人才梯队发展和人才储备及培养。`,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2020/10/11',
            toDate: '2021/01/23',
            toNow: false,
            isDisable: false,
            subject: '公司乙',
            major: '行政专员',
            content: `\n•拥负责本部的行政人事管理和日常事务，协助总监搞好各部门之间的综合协调，落实公司规章制度，沟通内外联系，保证上情下达和下情上报，负责对会议文件决定的事项进行催办、查办和落实，负责全公司组织系统研讨和修订。
            \n •编制公司人事管理制度，规避各项人事风险。`
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '荣誉证书',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: false,
        subject: '',
        major: '',
        content: `\n1、英语四级，听说读写能力良好，能流利的用英语进行日常交流，能快速浏览英文文档和书籍；
          \n2、通过全国计算机二级考试，熟练运用office等常用的办公软件。
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `工作积极认真，细心负责，熟练运用办公自动化软件，善于在工作中提出问题、发现问题、解决问题，有较强的分析能力；勤奋好学，踏实肯干，动手能力强，认真负责，有很强的社会责任感；坚毅不拔，吃苦耐劳，喜欢迎接新挑战。`,
        children: []
      }
    ]
  },
  // 2、算法工程师-简历模板
  {
    postTitle: '算法工程师-简历模板',
    title: '算法工程师简历',
    showTags: ['IT互联网', '算法工程师'], 
    id: 2,
    styleType: 'normal2Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_lkuvZny617443792480454674.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '算法工程师',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '10k-20k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '女',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2019/09/01',
        toDate: '2023/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX大学',
        major: 'XXXX专业',
        content: `
        \n1、专业课程：数字电子技术、C语言程序设计、数据通信与网络等
        \n2、所获奖项：2019全国大学生电子设计大赛一等奖，2019年校内二等奖学金
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '实习经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/5/1',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: '上海XXXX科技有限责任公司',
        major: '后端算法工程师',
        content: `\n**公司简介：** XXX公司是世界500强企业之一，是XX交所挂牌上市公司，股票代码为XXX，是XXX行业领跑者
          \n**工作内容**： 
          \n1.深度学习图像分割模型在Android端移植；
          \n2.负责XX大学开发的流量识别算法在Android端的迁移； 
          \n3.使用Opencv图像处理库在Android端进行算法的预处理、后处理。
          \n**主要技术**：
          \n语言：Python，Java；框架：Pytorch，Onnxruntime，DeelabV3+；多媒体处理工具：Android-Opencv，FFmpeg；
          `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '项目经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/10/11',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: 'XXX图像生成模型统筹',
        major: '算法实现与评估',
        content: `
        \n**项目描述**:在深度学习、计算机视觉及人工智能领域,高质量、多样化的数据集是驱动模型性能提升的关键因素。然而现实世界中往往存在数据稀缺、标注成本高、数据分布不均衡等问题,限制了模型训练的效果和泛化能力。本项目旨在通过融合传统图像处理技术、深度学习算法及最新生成模型(如 CNN、Stable Diffusion 等),开发一套高效的数据集扩充与生成系统,以应对上述挑战。
        \n**工作内容**:
        \n1.负责传统数据增强算法的设计与调优;
        \n2.负责风格迁移算法的选择与实现;
        \n3.图像和谐化的选择与实现;
        \n4.对文生图数据集结构解码,获取数据集格式,解读 pickle 文件,设计文生图的文本描述;
          `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2020/10/11',
            toDate: '2021/01/23',
            toNow: false,
            isDisable: false,
            subject: 'XXX感知装备研发运营管理平台',
            major: 'AI算法工程师',
            content: `
            \n**项目介绍**:建设XXX感知装备研发运营管理平台，实现研发测试和设备运维的数据化、自动化，以信息化手段提升产品研发和运营效率，降低人力、时间成本，为相关人员提供便利的软硬件工具，精准解决每台设备问题，为产品升级提供数据支撑。
            \n**工作内容**:
            \n1.解决在同一个环境下部署多个深度学习算法，如风格迁移、图像质量增强以及数据预测; 
            \n2.不同算法依赖不同模型、框架的兼容性问题，提升服务可持续和可维护性;
            \n3.将不同算法部署为服务，供管理平台调取。
            \n**主要技术**:
            \n语言:Python,Java;框架：Pytorch，Tensorflow，Onnxruntime，CAP-VSTNet风格迁移，ModernTCN数据预测，FBCNN图像质量增强；数据处理：Opencv、Numpy、Pandas、PIL、io；
            `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '专业技能',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: false,
        subject: '',
        major: '',
        content: `
          \n1、掌握Python,Windows,Pytorch,Linux多线程,VMware虚拟机,多进程方法及使用；
          \n2、熟练使用计算机辅助工作任务、熟悉AndroidStudio、熟悉Java语言、C语言；
          \n3、熟练掌握阅读相关英文论文和专利能力。
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n1.掌握扎实的深度学习算法，具备在算法设计和实现方面的专业技能，以及强大的实践能力。熟练掌握Python、Java、C语言编程，及TensorFlow和PyTorch深度学习框架，OpenCV和NumPy等图像处理和机器学习算法；精通目标检测、图像生成、图像分割等图像处理任务，具备模型实现、训练及后处理的丰富经验；熟悉CNN、GAN、Transformer和Diffusion Model等主流深度学习模型算法，并能够将深度学习模型有效地部署在不同操作系统。
        \n2.有丰富AI算法实操经验，在校期间累计做过近5个算法研发项目，项目成果和表现得到导师和客户的高度认可；
        \n3.拥有重点大学硕士学位，具备出色的学习能力和对算法工作的极大热情。除了专业课程，我还通过自学完成了多个算法相关的高级课程和项目，不断提升专业技能。
        \n4.性格乐观开朗、注重细节、认真负责，对生活充满热情，在工作中注重团队精神；
        `,
        children: []
      }
    ]
  },
  // 3、行业研究助理-简历模板
  {
    postTitle: '行业研究助理-简历模板',
    title: '行业研究助理简历',
    showTags: ['助理研究员'], 
    styleType: 'normal2Style',
    id: 3,
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_It3GPlY317443795123531965.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '行业研究助理',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '10k-20k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '女',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2019/09/01',
        toDate: '2023/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX大学',
        major: 'XXXX专业',
        content: `
        \n**专业课程**： 经济学、金融学、统计学、会计学、市场营销、国际金融、投资学、金融工程、金融风险管理等
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/5/1',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: '广发证券',
        major: '行业研究实习生',
        content: `
          \n**工作内容**： 
            \n1、研究报告撰写：参与撰写《中国消费信贷业务趋势研究》等策略报告，独立负责互联网金融企业发展沿革、国际消费金融市场回顾、消费金融风险指标分析等关键部分，为团队提供深度见解和数据支持 
            \n2、课题研究与资料整理：参与多个委托课题的研究工作，负责资料收集、整理与翻译。涉及课题包括国际ESG投资借鉴、中美科创板制度比较、美国金融风险分析等，积累了丰富的跨领域研究经验 
            \n3、数据分析工具开发：运用VBA编程技术，制作策略组白马双周报选股模板和个股估值历史分位工具，显著提升团队数据分析效率。 
            \n4、周报撰写与翻译：协助撰写策略周报部分内容，并负责首页翻译工作，确保信息准确传达，也得到上级高度认可.
          `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2020/10/11',
            toDate: '2021/01/23',
            toNow: false,
            isDisable: false,
            subject: '中信证券',
            major: '汽车行业研究助理',
            content: `
            \n**工作内容**：
            \n1、市场分析与报告撰写：独立完成新能源汽车市场发展报告，深入分析我国新能源汽车发展现状，研究智能汽车发展前景及投资机会 
            \n2、核心赛道研究：深入挖掘智能汽车三大核心子赛道：车外智能（ADAS）、智能座舱、电动智能化。从发展历史、竞争格局、发展趋势等角度，分析传感器、芯片、操作系统、线控底盘、语音交互、动力电池等细分产业链的投资机会，并深入研究其龙头企业 
            \n3、企业业绩测算与动态跟踪：基于历史数据和业务增长指标，完成比亚迪、XXX的业绩测算。持续跟踪长城、比亚迪、上汽、吉利等整车厂以及XXX汽车电子厂的公司动态，独立完成多家企业的案头研究及年报点评报告。
            `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '项目经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/10/11',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: 'XXX图像生成模型统筹',
        major: '算法实现与评估',
        content: `
        \n**项目描述**:在深度学习、计算机视觉及人工智能领域,高质量、多样化的数据集是驱动模型性能提升的关键因素。然而现实世界中往往存在数据稀缺、标注成本高、数据分布不均衡等问题,限制了模型训练的效果和泛化能力。本项目旨在通过融合传统图像处理技术、深度学习算法及最新生成模型(如 CNN、Stable Diffusion 等),开发一套高效的数据集扩充与生成系统,以应对上述挑战。
        \n**工作内容**:
        \n1.负责传统数据增强算法的设计与调优;
        \n2.负责风格迁移算法的选择与实现;
        \n3.图像和谐化的选择与实现;
        \n4.对文生图数据集结构解码,获取数据集格式,解读 pickle 文件,设计文生图的文本描述;
          `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '实践经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/10/11',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: 'XXXX全球XXX分析大赛',
        major: '校队队长',
        content: `
        \n**项目描述**：
        \n1、从行业、公司、财务、估值、风险等角度对消费行业餐饮公司XXX的基本面进行分析，确定整体投资逻辑，并使用 DCF 和P/E 等方法进行估值，完成 20 页全英文公司深度研究报告并英文展示； 
        \n2、作为队长，带领队伍从亚太地区近千支本科和研究生队伍中脱颖而出，作为唯一的中国队伍晋级亚太赛区前三强，并获得历届中国队最好成绩。
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n**专业背景**：金融专业，熟悉企业信用评估分析与金融科技监管业务，能够迅速理解金融业务运行原理并梳理需求。 
        \n**金融财务分析能力**：通过CFA二级考试，CPA通过会计、财务成本管理、经济法三门，具备扎实的财务分析能力。 
        \n**数据处理能力**：熟练使用Wind、Bloomberg等金融数据库，擅长运用Python、VBA、Matlab、SQL等工具进行高效数据处理与分析。 
        \n**语言能力**：托福106/120，日语N2，具备出色的双语读写能力。
        \n**研究能力**：对研究工作充满热情，具有强烈求知欲，善于通过数据可视化手段多角度剖析问题，逻辑思维与自驱力强，能够深入探究研究中的复杂问题。
        `,
        children: []
      }
    ]
  },
  // 4、电商运营-简历模板
  {
    postTitle: '运营/网店店长-简历模板',
    title: '运营/网店店长简历',
    showTags: ['网店店长', '运营'],
    styleType: 'normal3Style',
    id: 4,
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_RMtxCRcr17443792841851021.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '运营/网店店长',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '8k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '女',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2019/09/01',
        toDate: '2023/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX大学',
        major: 'XXXX专业',
        content: `
        \n**专业课程**：营销学、电子商务等
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/5/1',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: '淘宝网店',
        major: '网店店长',
        content: `
         \n**职责业绩**: 化妆品网店销售
          \n1.品牌甄选：整理资源，寻找品牌和产品，谈妥合作形式，进货折扣，结算周期 
          \n2.店铺运营：平台注册和店铺更新（熟悉平台规则，选品作图，测款，上下架sku，标题优化，数据异常监控处理） 
          \n3.活动策划执行：日常促销（活动设置）&大促报名优化和复盘（618，双11，双12） 
          \n4.产品推广：结合销售数据进行直通车计划优化调整，优化ROI 
          \n5.客服维护：跟进顾客日常咨询，回复相关问题，提升顾客购物体验和复购率，店铺好评率98% 
          \n6.仓储物流：合作快递洽谈，仓库打包发货，售后退货异常处理 
          \n7.营业表现：完成店铺从0-1搭建，各项评分行业中上，单店23年单月度最高销售12w
          `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/7/11',
            toDate: '2023/02/23',
            toNow: false,
            isDisable: false,
            subject: '环球易购',
            major: '电商运营',
            content: `
            \n**职责业绩**: 
            \n•负责店铺产品上下架、推广营销等,有效提升店铺及产品的访问量
            \n•负责店铺日常维护更新及销售监控,优化店铺及产品排名
            `
          },
          {
            id: uuidv4(),
            sort: 2,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/10/11',
            toDate: '2023/01/23',
            toNow: false,
            isDisable: false,
            subject: '广州XX化妆品有限公司',
            major: '销售推广',
            content: `
            \n**职责业绩**: 
            \n1.销售目标承接和分解，寻找客户出货机会点，月度销售目标，同比接手前客户销售稳中有升，终端零售份额递增20% 2.渠道巩固和客户开拓，扶持核心四川代理商并拓展云南，重庆代理商3家和区域内系统、零售商客户开拓10家 
            \n3.销售方案策划与活动实施跟进，区域、连锁、单店活动、沙龙美课、网红探店、秒杀方案制定执行,带动店铺销售增长 
            \n4.培训产品和项目卖点提炼，课件制作整理和授课，完善市场客户的培训机制和形式(微信，直播，录播视频，现场培训) 5.销售数据分析总结，按照时间维度对金额目标、品类目标、执行事件目标做达成分析和复盘，探索突破机会点并实现。
            `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n1、在多领域积累了丰富工作经验,学习能力强,能快速适应新工作与环境,拥有快速试错与迭代能力
        \n2、对新媒体运营岗位充满热情,运营个人小红书账号,累计发布48篇原创内容,单篇最高曝光量达4万+,点赞收藏量达2千+
        \n3、有化妆品区域销售管理经验，和丰富的大型美妆连锁品牌拓展开店及店铺运营工作经验
        \n4、严谨的工作计划和积极的团队协作能力，可以承受较大工作压力，个性开朗乐观
        `,
        children: []
      }
    ]
  },
  // 5、物流经理-简历模板
  {
    postTitle: '物流经理-简历模板',
    title: '物流经理简历',
    showTags: ['物流', '经理人'], 
    styleType: 'normal2Style',
    id:5,
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PVPRNj1O17443793088085701.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '物流经理',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '8k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '男',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2019/09/01',
        toDate: '2023/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX大学',
        major: 'XXXX专业',
        content: `
        \n**专业课程**：物流管理、供应链管理、仓储管理等.
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/5/1',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: 'XXXX物流公司',
        major: '物流经理',
        content: `
        \n**职责业绩**：负责物流业务指标达成，门店/外包/代理商的人员结构优化稳定，大促期间的应急保障等，团队30+。
        \n**业务达成**：
        \n①存量客户维护深耕，工业区配件客户业务持续突破；
        \n②新马泰日韩优势线路推广，抓住国际业务增量；
        \n③短平快业务开发：部队行李寄递，提升包装及时效业务量；5月业务达标110%，增量提升8%。
        \n**降本增效**：
        \n①推动代理商新能源货车投入，降低单票成本；
        \n②小哥三轮换公司依维柯，提高作业效率和客户粘性；
        \n③高峰应对：兼职/超市/家属等多模式用工；
        \n④区域拆分，拉齐小哥人效及薪资；单票人力成本下降8%-12%。
        \n**团队建设**：
        \n①坚持361原则，树标杆、强小组、淘汰价值观不符；
        \n②落实正负激励，加强情感关怀。
          `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/7/11',
            toDate: '2023/02/23',
            toNow: false,
            isDisable: false,
            subject: 'XXXXX快递公司',
            major: '物流经理',
            content: `
            \n**工作职责**： 
            \n1.主要负责区域营销团队的组建，门店人员轮转淘汰及团队人员培训管理。 
            \n2.负责区域业务销售人员KPI指标的制定，以及落地执行监督。 
            \n3.区域早会晚会工作部署，确早会定每日任务销售人员的知晓和达成，晚会区域日常工作完成质量检查，未达成人员的后期营销完成举措解析。 
            \n4.目前任XX德邦物流有限公司营业部经理，主要负责XX，XX部分区域。 
            \n5.完成公司下发快运任务，客户协助开发与维护，区域异常处理。 
            \n6.快递员的招聘培训与管理，分配快递员指标并协助客户开发 
            \n**工作业绩**： 
            \n1.任职初期将销售区域- XXX大道业务片区从XX大区销售45提升至第8，用时5个月，锁定XX区域家具增量10万，电商客户增量5万，开发XX区域电商家具客户，区域快运任务做到20号之前完成，目前任职区域-XX区域已从初期的月均30万体量达到目前月均60万，6.18，双十一期间达到75万销售业绩提升1倍以上，用时8个月。 
            \n2.自开展快运业务以来，销售区域累计开发客户30多家，客户属性包含3PL，生产型直客，电商型客户，整车钢结构型客户；区域客户基数夯实，大客户较多且稳定，客户结构黏性较强。 
            `
          },
        ]
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n1、拥有8年物流行业经验，对物流调度有深刻理解与丰富实践经验，能高效规划运输路线，优化配送流程，确保货物准时送达，降低运营成本，提升整体物流效率。
        \n2、扎实的数据分析、快递运营以及同城货运管理经验，在数据运营、仓配优化、降本增效、团队建设有突出成就；
        \n3、积极乐观，乐于学习，善于从数据中拿取结果。
        `,
        children: []
      }
    ]
  },
   // 6、实习语文教师-简历模板
   {
    postTitle: '实习语文教师-简历模板',
    title: '实习语文教师简历',
    showTags: ['教师'], 
    styleType: 'normal1Style',
    id: 6,
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_7KERunDM17443793409848382.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '实习语文教师',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '7k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '政治身份',
          basicVal: '中共党员',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育背景',
        edit: false,
        isAppear: true,
        fromDate: '2019/09/01',
        toDate: '2023/07/01',
        toNow: false,
        isDisable: false,
        subject: '北京师范大学',
        major: '本科-汉语言文学',
        content: `
        \n**专业成绩前20%,曾获得1次一等奖学金、2次二等奖学金**
        \n**主修课程**:现代汉语、古代汉语、中国文学史、外国文学、文学概论、教育学、心理学
        \n**研究项目及论文**:
        \n《红楼梦》专题研究:参与校内文学研究小组,深入研究《红楼梦》的艺术特点和文化价值,撰写论文《红楼梦中的女性形象及其文化意义》,发表在《文学评论》杂志上
        语言学实验室项目:参与语言学实验室的多项研究项目,进行语言数据采集和分析,发表研究报告《现代汉语新词汇的语义演变》,在校内学术会议上进行汇报
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/5/1',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: '华南XX大学附属中学',
        major: '实习语文教师',
        content: `
        \n1、教学设计与实施: 负责高一年级语文教学,独立设计并实施教学计划,涵盖古诗文、现代文等多个模块。通过生动有趣的教学方法,提升学生的学习兴趣和理解能力。
        \n2、读书会组织: 组织并主持了多次班级读书会,激发学生阅读兴趣,提高学生文学素养,帮助学生拓宽阅读视野。
        \n3、课堂评价与反思: 在指导教师帮助下,完成了多次课堂教学评价并撰写反思报告,通过不断反思与改进,提升了自身教学能力
        \n4、家校沟通: 与家长保持良好沟通,定期汇报学生的学习情况,形成家校合作的良好氛围。
          `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/7/11',
            toDate: '2023/02/23',
            toNow: false,
            isDisable: false,
            subject: '广州市XX小学',
            major: '实习班主任助理',
            content: `
            \n1、班级管理:协助班主任管理班级日常事务,维护班级纪律,促进良好班风。通过与学生的日常接触,了解并解决他们在学习和生活中的问题。
            \n2、活动策划与组织:参与策划和组织学校的各类活动,如运动会、文化节等,增强学生的团队合作精神和集体荣誉感。
            \n3、个别辅导:负责个别学生的学业辅导,帮助他们提高学习成绩和自信心。通过因材施教的方法,针对学生的不同需求,提供个性化辅导。
            \n4、心理辅导:在实习期间参与学校的心理健康教育活动,帮助学生处理心理压力和情感问题,促进学生的身心健康发展。
            `
          },
        ]
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n**教育背景**：北京师范大学汉语言文学专业，参与《红楼梦》和语言学实验室项目，发表学术论文。 
        \n**实践能力**：在广州知名小学和中学担任过实习班主任助理和语文教师，具备班级管理和教学设计经验。 
        \n**综合素质**：热爱教育事业，对待学生耐心细致，责任心强，善于沟通，能够处理多任务并具备良好的团队合作精神。
        \n**专业技能**：具备独立研究和论文撰写能力，能够进行有效的个别辅导和心理辅导。
        `,
        children: []
      }
    ]
  },
  // 7、导游/旅行顾问-简历模板
  {
    postTitle: '导游/旅行顾问-简历模板',
    title: '导游/旅行顾问简历',
    showTags: ['导游'], 
    styleType: 'normal3Style',
    id: 7,
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_JIkJzXWT17443793744033075.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '导游/旅行顾问',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '7k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育背景',
        edit: false,
        isAppear: true,
        fromDate: '2019/09/01',
        toDate: '2023/07/01',
        toNow: false,
        isDisable: false,
        subject: '北京XX大学',
        major: '本科-旅游管理专业',
        content: `
        \n**专业成绩前20%,曾获得1次一等奖学金、2次二等奖学金**
        \n**主修课程**:旅游学、旅游市场营销、旅游地理学、旅游心理学、旅游英语、导游实务、旅游法规等
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/5/1',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: '俄罗斯XXX旅行社',
        major: '金牌导游',
        content: `
       \n**工作内容**：
        \n1、累积接待40人以上中型旅游团近百次，3-8人小型vip团二十余次； 
        \n2、参与制定最新旅游产品的路线及报价； 
        \n3、主管负责公司新导游的招聘及讲解词教材的编写工作。
        \n4、负责会议执行服务，确保每位客人都能享受到专业、周到的服务体验。
        \n5、积极与客人沟通交流，了解并满足其需求，成功获取多次客人的好评反馈。  
          `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/7/11',
            toDate: '2023/02/23',
            toNow: false,
            isDisable: false,
            subject: 'XXX旅行社股份有限公司',
            major: '入境旅游接待讲解员(俄语）',
            content: `
            \n**工作内容**：
            \n1、导游讲解：为俄罗斯旅行团队提供导游讲解服务，讲解张家界景区的历史、文化、风俗、习惯、地理等相关内容。 
            \n2、组织管理：组织和带领团队参加旅游活动，管理成员，确保过程中秩序井然。 
            \n3、管理协调：协调各方面的工作，包括行程安排、车辆等，确保计划圆满完成。  
            `
          },
        ]
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n1、有近十年海外留学经历，熟悉俄罗斯及其他俄语系国家社会状况，风土人情等。 留学期间曾任莫斯科国立大学中国留学生会副主席，主办组织过五场以上千人级别，面向全体当地华人的大型晚会等活动。 
        \n2、曾两次协助中华人民共和国驻XXX总领馆完成国家重要领导人的接待工作。 
        \n3、现为阅文集团二级签约作者，作品累积超过百万字，平均订阅人数近千，有一定的文字工作能力。
        `,
        children: []
      }
    ]
  },
  // 8、月嫂/育婴师-简历模板
  {
    postTitle: '月嫂/育婴师-简历模板',
    title: '月嫂/育婴师简历',
    id: 8,
    showTags: ['生活服务'], 
    styleType: 'normal3Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_NvIbwLlo17443794063422783.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '月嫂/育婴师',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '7k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育背景',
        edit: false,
        isAppear: true,
        fromDate: '2019/09/01',
        toDate: '2023/07/01',
        toNow: false,
        isDisable: false,
        subject: '北京XX大学',
        major: '本科',
        content: `
        \n**主修课程**: 护理学、护理心理学、护理伦理学、护理法规等
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/5/1',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: 'XXX家政服务有限公司',
        major: '月嫂/育婴师',
        content: `
        \n1.定期参加公司的专业技能培训，提升专业能力。 
        \n2.上门护理产妈妈和宝宝，如给宝妈做乳房护理和身体按摩服务等，给新生儿做排气操、洗澡、抚触、肚脐消毒等服务
        \n3.宣教，给全家人宣如何教科学母婴护理。 
        \n4.多次获得宝妈的转介绍和锦旗。  
          `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/7/11',
            toDate: '2023/02/23',
            toNow: false,
            isDisable: false,
            subject: 'XXX母婴家政服务有限公司',
            major: '月嫂/育婴师',
            content: `
            \n1、专注于婴儿的全面护理：每日细致观察并记录宝宝的身体状况和需求，提供专业的喂养、清洁和安抚服务。确保宝宝健康成长。
            \n2、密切关注宝妈的身心状态，协助其进行身体恢复和情绪调节。
            \n3、及时沟通并上报任何问题，确保客户需求得到快速响应，提升客户满意度和信任度。  
            `
          },
        ]
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n1. 拥有8年工作经验，深耕月子中心领域，2019年获得高级育婴师证书，具备扎实的专业技能和丰富实践经验，能够为母婴提供全方位、高质量的护理服务。 
        \n2. 长期在月子中心任职，熟悉行业标准与流程，积累了丰富的客户资源和服务经验，能精准把握客户需求，提供优质个性化的产后护理方案。 
        \n3. 本人性格细心内敛，善于沟通，对工作态度端正，热爱学习 
        `,
        children: []
      }
    ]
  },
  // 9、销售经理-简历模板
  {
    postTitle: '销售经理-简历模板',
    title: '销售经理简历',
    showTags: ['销售', '经理人'], 
    styleType: 'normal2Style',
    id: 9,
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_r6y1KNEG17443794383131821.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '销售经理',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '7k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: '123@qq.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育背景',
        edit: false,
        isAppear: true,
        fromDate: '2019/09/01',
        toDate: '2023/07/01',
        toNow: false,
        isDisable: false,
        subject: '北京XX大学',
        major: '心理学',
        content: `
        \n**主修课程**: 心理学、销售心理学、销售伦理学、销售法规等
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/5/1',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: '格力空调',
        major: '区域销售经理',
        content: `
          \n**工作内容**： 
          \n1.负责空气侧产品在江浙沪地区的市场及销售工作，主要为民用市场，包括商业综合体，办公楼，政企单位。
          \n2.团队8人，年销售合同额两个亿左右。每年接近30%的增长。  	
          `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/7/11',
            toDate: '2023/02/23',
            toNow: false,
            isDisable: false,
            subject: 'XXXXX有限公司',
            major: '客户经理',
            content: `
            \n**工作内容**： 
            \n1.负责 B2B 快销平台区域运营，行销工作，在武昌、洪山、青山、黄陂、麻城、罗田、鄂州、英山、团凤等地 与合作经销商共计开拓用户数 3500 余家，用户活跃率 50%以上，GMV300 万元。
            \n2.开发维护合作经销商 7 家，为合作经销商团队提供相关业务培训，制定销售目标，追踪目标的达成，2018 年 9 月订货节活动，协助新开合作经销商运营 3 天销量达 70 万元，三天 GMV 上浮 70 万元，高达日常流量 30 倍
            \n3.负责开拓、运营京东便利店 17 家；连续半个月不休息每天工作 16 个小时成功开出湖北省第一家京东便利店， 当日 GMV 近 3 万元。    	
            `
          },
          {
            id: uuidv4(),
            sort: 2,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/7/11',
            toDate: '2023/02/23',
            toNow: false,
            isDisable: false,
            subject: 'xxxxx酒店管理公司',
            major: '酒店渠道销售经理',
            content: `
            \n**工作内容**： 
            \n1.负责XXXXX酒店产品线在华东, 西北区域的销售
            \n2.拿到公司内部Brava销售贡献奖
            \n3.拿下华东地区多个酒店地标项目。占据奢华酒店50%以上的市场份额。
            \n**项目案例**：上海苏宁宝丽嘉，上海宝格丽，上海虹桥凯悦，南京卓美亚，南京丽思卡尔顿，南京凯宾斯基酒店等。 	
            `
          },
        ]
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n1、职业背景：就职于世界500强企业 10 年销售管理从业经验，精熟空调市场销售运作管理模式，拥有战略规划/销售管理/区域市场拓展/经销商开发管理/费用管控/团队打造的丰富经验，管理最高销售规模10亿。 
        \n2、核心优势：具备“战略布局+财务思维+体系搭建+市场洞察+线上线下联动+管理创新+困境突破”能力。 
        \n3、团队管理：优秀的团队领导者和协作者，以业绩和价值导向，通过组织迭代/分权/授权/放权/激活团队。 
        \n4、综合能力：在经历传统零售结构调整、新零售发展过程中，有敏锐的市场洞察力，抗压能力强，精通渠道开发与销售管理，具有清晰的业务思路与良好的商务谈判能力，具备全格局视野。
        `,
        children: []
      }
    ]
  },
  // 10、Java开发-简历模板
  {
    postTitle: 'Java开发-简历模板',
    title: 'Java开发简历',
    showTags: ['IT互联网', 'Java开发'], 
    id: 10,
    styleType: 'normal2Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_2bnVWUgM17443794670049777.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: 'Java开发',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '7k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: '123@qq.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育背景',
        edit: false,
        isAppear: true,
        fromDate: '2019/09/01',
        toDate: '2023/07/01',
        toNow: false,
        isDisable: false,
        subject: '北京XX大学',
        major: '计算机科学',
        content: `
        \n**成绩排名**：本科硕士专业成绩排名前20%
        \n**荣誉奖项**：州立大学全额奖学金，复旦专业二等奖学金、复旦大学“至善学子”奖、优秀学生干部 
        \n**竞赛获奖**：上海市第八届“互联网+”大学生创新创业大赛省一等奖
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 2,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/5/1',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: '美团公司',
        major: 'Java软件开发(实习)',
        content: `
          \n**工作职责**：
          \n● 负责美团APP XXXX游戏的后端逻辑开发，确保功能稳定性和高效性 
          \n● 参与GM后台的架构设计，优化系统性能
          \n● 与产品团队紧密合作，根据需求迭代更新后端服务，满足业务发展需求 
          \n● 负责后端服务的日常维护，及时处理线上问题，确保系统稳定运行  	
          `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/7/11',
            toDate: '2023/02/23',
            toNow: false,
            isDisable: false,
            subject: '腾讯公司',
            major: 'Java后端开发',
            content: `
            \n1、工作职责：负责PCG腾讯文档部门文档管理和客户端后台模块的Java开发实习工作
            \n2、项目目标：提升大盘DAU和七日留存,提升基建能力和模块用户体验
            \n3、关键动作：双端云本地混排混搜功能提升文档管理模块
            \n4、用户体验：帮助协调管理在线与本地文档,处理离线/免登等边界场景,提升基建能力。桌面端自动更新机制提升用户升级率;多设备管理功能,提升基建能力和用户体验
            \n5、业绩成果：双端用户七日留存由13.8%上升至38.6%  	
             `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '项目经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/10/11',
        toDate: '2021/01/23',
        toNow: false,
        isDisable: false,
        subject: 'XXXX小游戏',
        major: '后端开发',
        content: `
        \n**1.项目概述**：XX权益流量游戏，用于增加用户美团APP使用时长，为美团外卖、骑行等核心业务推流。参与开发娱乐得奖、活动中心等多个游戏模块以及日常产品需求迭代；开发过程涉及技术栈包括存储、消息队列、RPC、Redis分布式锁等等。
        \n**2.项目职责**:
        \n本人负责游戏Java后端开发，完成产品功能需求。
          `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2020/10/11',
            toDate: '2021/01/23',
            toNow: false,
            isDisable: false,
            subject: 'XXX代码XXX平台',
            major: '后端开发',
            content: `
            \n**1.项目描述**: 本项目为开发一款简单易上手的面向大学生的代码托管平台，以 Git 版本控制为核心，基于Vue3+SpringBoot框架进行开发，平台主要包括代码管理、历史分支管理、issue、pull request 等核心业务流。
            \n**2.项目职责**:
            \n个人在该项目中参与需求分析、系统设计、编码、测试和部署，其中编码阶段负责绝大部分后端（Java），主要包括逻辑处理、数据库交互（MySQL、Redis）、Git 嵌入。
            `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n1、本硕均为中美知名院校，美国计算机博士,在校期间获奖经历丰富。 
        \n2、计算机基础扎实,项目经验丰富,代码严谨规范，解决问题的思路严谨而有创造性，有产品/商业思维和丰富实习经历。
        \n3、精通Java后端开发，熟悉深度学习、强化学习、算法、软件工程、图形学的技能和常用框架。
        `,
        children: []
      }
    ]
  },
  // 11、酒店前台-简历模板
  {
    postTitle: '酒店前台-简历模板',
    title: '酒店前台简历',
    showTags: ['服务业', '酒店前台'], 
    id: 11,
    styleType: 'normal7Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_NKZTAtBc17552634954263592.jpeg",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '酒店前台',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '5k-8k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '工作年限',
          basicVal: '1 - 3年',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: 'example@163.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '女',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/09/01',
        toDate: '2024/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX大学',
        major: '酒店管理专业',
        content: '**主修课程**：酒店管理概论、前厅客房管理、餐饮服务管理、酒店英语、旅游学概论、服务礼仪、酒店财务管理、酒店市场营销等',
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2022/06/01',
        toDate: '2024/03/01',
        toNow: false,
        isDisable: false,
        subject: '五星级国际酒店',
        major: '前台接待员',
        content: `**工作职责**：
\n• 负责客人入住登记、退房结算等前台接待服务，熟练操作酒店管理系统（PMS）
\n• 处理客人预订、查询、投诉等各类问题，确保客户满意度
\n• 协调客房部、餐饮部等各部门，为客人提供全方位服务
\n• 负责夜班值班工作，处理紧急情况和突发事件
\n• 维护前台区域整洁，管理钥匙、邮件等物品

**工作业绩**：
\n• 客户满意度评分保持在95%以上，多次获得客人表扬信
\n• 熟练掌握中英文接待服务，能够为外籍客人提供专业服务
\n• 协助培训新员工5名，提升团队整体服务水平`,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2021/07/01',
            toDate: '2022/05/31',
            toNow: false,
            isDisable: false,
            subject: '商务连锁酒店',
            major: '前台实习生',
            content: `**实习内容**：
\n• 学习前台接待基础流程，包括客人接待、电话应答、房态管理等
\n• 协助正式员工处理客人入住退房手续，学习酒店管理系统操作
\n• 参与酒店日常运营管理，了解各部门协作流程
\n• 学习处理客人投诉和特殊需求，提升沟通协调能力

**实习收获**：
\n• 掌握酒店前台基本操作流程和服务标准
\n• 提升了客户服务意识和沟通表达能力
\n• 获得实习优秀学员称号`
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '专业技能',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `• **语言能力**：普通话标准，英语CET-4，口语流利，能够进行日常商务交流
\n• **计算机技能**：熟练使用Office办公软件，掌握Opera、Fidelio等酒店管理系统
\n• **服务技能**：具备良好的服务礼仪和沟通技巧，能够处理各类客户问题
\n• **证书资质**：酒店管理师证书、客房服务员资格证书`,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `**服务意识强**：热爱酒店服务行业，具有强烈的客户服务意识，能够急客人之所急，想客人之所想，始终以客人满意为工作目标。

\n**沟通能力佳**：性格开朗，善于与人沟通，能够用亲切的态度和专业的服务赢得客人的信任和满意，具备处理突发情况的应变能力。

\n**团队协作能力**：具有良好的团队合作精神，能够与同事密切配合，协调各部门关系，确保酒店整体服务质量。

\n**学习能力强**：对新知识接受能力强，能够快速掌握新的工作流程和系统操作，持续提升自己的专业服务水平。`,
        children: []
      }
    ]
  },
  // 12、便利店店员/营业员-简历模板
  {
    postTitle: '便利店店员/营业员-简历模板',
    title: '便利店店员/营业员简历',
    showTags: ['零售业', '便利店店员', '营业员'], 
    id: 12,
    styleType: 'normal9Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_SvGBRvQb1755263155483416.jpeg",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '便利店店员/营业员',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '4k-6k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '工作年限',
          basicVal: '1 - 2年',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: 'example@163.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '男',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2021/09/01',
        toDate: '2024/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX学校',
        major: '高中/中专',
        content: '**主修课程**：计算机基础、市场营销、商务礼仪、财务基础等',
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2023/03/01',
        toDate: '2024/06/01',
        toNow: false,
        isDisable: false,
        subject: '7-11便利店',
        major: '店员',
        content: `**工作职责**：
\n• 负责收银结账，熟练操作POS收银系统，确保账目准确无误
\n• 负责商品理货上架、补货、整理货架，保持商品陈列整齐有序
\n• 处理商品过期检查，及时下架过期商品，确保食品安全
\n• 负责店内清洁卫生，包括地面、货架、冷柜等设备的日常清洁
\n• 为顾客提供咨询服务，介绍商品信息，处理顾客投诉和建议
\n• 协助店长进行库存盘点和商品订货工作

**工作业绩**：
\n• 收银准确率保持在99.8%以上，零现金差错记录
\n• 月销售额完成率达到110%，多次获得月度优秀员工称号
\n• 积极学习商品知识，能够为顾客提供专业的商品咨询服务`,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/06/01',
            toDate: '2023/02/28',
            toNow: false,
            isDisable: false,
            subject: '全家便利店',
            major: '兼职店员',
            content: `**工作内容**：
\n• 负责早晚班收银工作，处理各种支付方式（现金、支付宝、微信等）
\n• 协助正式员工进行商品理货和货架整理工作
\n• 学习便利店基本操作流程，包括商品分类、价格管理等
\n• 参与店内促销活动的宣传和执行工作

**工作收获**：
\n• 掌握了便利店基本操作流程和收银系统使用
\n• 提升了与顾客沟通的技巧和服务意识
\n• 培养了细心负责的工作态度和团队协作精神`
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '专业技能',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `\n• **收银技能**：熟练操作各种POS收银系统，掌握现金、刷卡、移动支付等多种收银方式
\n• **商品管理**：熟悉商品分类、上架、理货、盘点等零售业务流程
\n• **计算机技能**：熟练使用办公软件，能够处理简单的数据统计和报表
\n• **服务技能**：具备良好的顾客服务意识和沟通技巧，能够处理各类顾客问题`,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `**责任心强**：工作认真负责，严格按照操作规范执行，能够保证工作质量和准确性，具有很强的责任感。

\n**服务意识佳**：热情友好，善于与顾客沟通，能够主动为顾客提供帮助和建议，具备良好的服务意识和亲和力。

\n**学习能力强**：对新事物接受能力强，能够快速学习和掌握新的工作技能和操作流程，持续提升自己的专业水平。

\n**团队合作**：具有良好的团队合作精神，能够与同事和睦相处，互相配合完成工作任务，维护良好的工作氛围。`,
        children: []
      }
    ]
  },
  // 13、人力资源(HR)-简历模板
  {
    postTitle: '人力资源(HR)-简历模板',
    title: '人力资源(HR)简历',
    showTags: ['人力资源'], 
    id: 13,
    styleType: 'normal8Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_NYwI78fa17552631434806492.jpeg",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '人力资源专员/主管',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '8k-15k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '工作年限',
          basicVal: '3 - 5年',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: 'hr@example.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '女',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2018/09/01',
        toDate: '2022/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX大学',
        major: '人力资源管理专业',
        content: '**主修课程**：人力资源管理、组织行为学、劳动关系学、薪酬管理、绩效管理、招聘与配置、培训与开发、劳动法律法规等\n\n**荣誉奖项**：校级二等奖学金、优秀学生干部、人力资源管理师三级证书',
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2023/01/01',
        toDate: '2024/08/01',
        toNow: false,
        isDisable: false,
        subject: 'XX科技有限公司',
        major: '人力资源专员',
        content: `**工作职责**：
\n• 负责公司招聘工作，制定招聘计划，发布招聘信息，筛选简历，安排面试
\n• 协助完成员工入职、离职手续办理，建立和维护员工档案
\n• 参与薪酬体系设计和绩效考核体系建设，协助处理员工薪酬福利事务
\n• 组织员工培训活动，制定培训计划，跟踪培训效果评估
\n• 处理员工关系，协调解决劳动纠纷，维护良好的企业文化氛围
\n• 协助制定和完善公司人事制度和流程，确保合规性

**工作业绩**：
\n• 成功招聘各类人才150+人，招聘达成率95%，大幅缓解公司用人需求
\n• 优化招聘流程，将平均招聘周期从30天缩短至20天，提升招聘效率
\n• 组织实施新员工培训项目，新员工转正率提升至92%
\n• 协助建立绩效考核体系，员工满意度调研结果显示满意度达88%`,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/07/01',
            toDate: '2022/12/31',
            toNow: false,
            isDisable: false,
            subject: 'XX贸易公司',
            major: '人力资源实习生',
            content: `**实习内容**：
\n• 协助HR主管处理日常招聘事务，学习简历筛选和面试技巧
\n• 参与员工入职培训的组织和实施工作
\n• 协助整理和更新员工档案，学习人事管理系统操作
\n• 参与员工活动策划，协助维护企业文化建设

**实习收获**：
\n• 熟悉了人力资源工作的基本流程和操作规范
\n• 提升了沟通协调能力和人际交往技巧
\n• 掌握了基本的招聘面试技能和人事系统操作
\n• 获得实习优秀学员称号和导师推荐信`
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '专业技能',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `\n• **招聘管理**：熟练掌握招聘流程设计、简历筛选、面试技巧、人才测评等招聘技能
\n• **薪酬绩效**：了解薪酬体系设计、绩效考核方案制定、激励机制建设等相关知识
\n• **培训发展**：具备培训需求分析、培训计划制定、培训效果评估等培训管理能力
\n• **劳动法规**：熟悉劳动合同法、社会保险法等相关法律法规，具备合规意识
\n• **系统操作**：熟练使用HR管理系统、Office办公软件、招聘网站等工具
\n• **证书资质**：人力资源管理师三级证书、心理咨询师三级证书`,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `**专业能力强**：具备扎实的人力资源专业知识基础，熟悉HR六大模块，能够独立完成招聘、培训、绩效等各项工作，持续关注行业发展趋势。

\n**沟通协调能力佳**：性格开朗，善于与不同层级的员工沟通交流，能够准确理解需求并有效传达信息，具备良好的人际关系处理能力。

\n**数据分析能力**：注重用数据说话，能够通过HR数据分析发现问题并提出改进建议，具备一定的数据敏感度和逻辑思维能力。

\n**学习适应能力强**：对新政策、新技术接受能力强，能够快速学习和应用新的HR工具和方法，持续提升自己的专业水平和工作效率。`,
        children: []
      }
    ]
  },
  // 14、工程造价-简历模板
  {
    postTitle: '工程造价-简历模板',
    title: '工程造价简历',
    showTags: ['工程造价', '工程管理'], 
    id: 14,
    styleType: 'normal2Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_r6y1KNEG17443794383131821.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '工程造价师',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '8k-15k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '工作年限',
          basicVal: '3 - 5年',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: 'engineering@example.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '男',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2018/09/01',
        toDate: '2022/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX大学',
        major: '工程造价专业',
        content: `
        \n**专业课程**：工程造价管理、工程经济学、建筑工程概预算、安装工程概预算、工程招投标与合同管理、工程项目管理、建筑法规、工程测量、建筑材料等
        \n**荣誉奖项**：校级二等奖学金、优秀毕业生、工程造价师职业资格证书
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2022/08/01',
        toDate: '2024/06/01',
        toNow: false,
        isDisable: false,
        subject: 'XX建设工程咨询有限公司',
        major: '工程造价师',
        content: `
        \n**工作职责**：
        \n• 负责工程项目概预算编制，包括土建、安装、装饰等各专业工程量的计算和造价分析
        \n• 参与工程招投标工作，编制投标报价文件，进行成本分析和风险评估
        \n• 负责工程结算审核，确保结算资料的完整性和准确性
        \n• 参与合同谈判，协助制定合同条款，控制工程造价风险
        \n• 使用广联达、斯维尔等专业软件进行工程量计算和造价分析

        \n**工作业绩**：
        \n• 独立完成15个项目的概预算编制，总造价约2.5亿元，准确率达95%以上
        \n• 参与8个大型项目的招投标工作，中标率达75%，为公司创造显著经济效益
        \n• 优化结算流程，将结算周期缩短20%，提高工作效率
        \n• 获得公司年度优秀员工称号，多次获得客户好评
        `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2021/07/01',
            toDate: '2022/07/31',
            toNow: false,
            isDisable: false,
            subject: 'XX建筑集团有限公司',
            major: '工程造价实习生',
            content: `
            \n**实习内容**：
            \n• 协助工程造价师进行工程量计算和造价分析工作
            \n• 学习使用广联达、斯维尔等专业软件，掌握工程量计算技巧
            \n• 参与项目现场勘查，了解施工工艺和材料使用情况
            \n• 协助编制工程预算书和结算书，学习造价管理流程

            \n**实习收获**：
            \n• 掌握了工程造价的基本工作流程和专业技能
            \n• 熟悉了相关法律法规和行业标准
            \n• 提升了数据分析和成本控制能力
            \n• 获得实习优秀学员称号
            `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '专业技能',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: false,
        subject: '',
        major: '',
        content: `
        \n• **专业软件**：熟练使用广联达、斯维尔、鲁班等工程造价软件，掌握AutoCAD、Excel等办公软件
        \n• **造价管理**：精通工程量计算、定额套用、材料价格分析、造价控制等专业技能
        \n• **招投标**：熟悉招投标流程，具备编制投标文件、进行成本分析和风险评估的能力
        \n• **法律法规**：熟悉《建设工程工程量清单计价规范》、《建设工程造价咨询规范》等相关法规
        \n• **证书资质**：工程造价师职业资格证书、注册造价工程师（在考）
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n**专业能力强**：具备扎实的工程造价专业知识，熟悉工程量计算、定额套用、造价控制等核心技能，能够独立完成各类工程项目的造价管理工作。

        \n**软件操作熟练**：精通广联达、斯维尔等专业软件，能够高效进行工程量计算和造价分析，具备较强的数据处理和分析能力。

        \n**责任心强**：工作认真负责，注重细节，能够严格按照规范要求完成各项工作，确保造价数据的准确性和可靠性。

        \n**学习能力强**：持续关注行业发展趋势和新技术应用，积极参加专业培训和考试，不断提升自己的专业水平和工作能力。
        `,
        children: []
      }
    ]
  },
  // 15、平面设计师-简历模板
  {
    postTitle: '平面设计师-简历模板',
    title: '平面设计师简历',
    showTags: ['平面设计', '设计师'], 
    id: 15,
    styleType: 'normal1Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_7KERunDM17443793409848382.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '平面设计师',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '6k-12k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '工作年限',
          basicVal: '2 - 4年',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: 'designer@example.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '女',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2019/09/01',
        toDate: '2023/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX艺术学院',
        major: '视觉传达设计专业',
        content: `
        \n**专业课程**：平面设计基础、字体设计、标志设计、包装设计、广告设计、UI设计、品牌设计、设计史、色彩构成、版式设计等
        \n**荣誉奖项**：校级设计大赛一等奖、优秀毕业生作品展、Adobe认证设计师证书
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2023/08/01',
        toDate: '2024/06/01',
        toNow: false,
        isDisable: false,
        subject: 'XX广告设计有限公司',
        major: '平面设计师',
        content: `
        \n**工作职责**：
        \n• 负责品牌视觉设计，包括logo设计、VI系统设计、品牌形象策划等
        \n• 完成各类平面设计项目，如海报、宣传册、包装设计、广告创意等
        \n• 与客户沟通需求，理解设计目标，提供专业的设计方案和建议
        \n• 参与项目创意讨论，提供设计思路和创意方向
        \n• 负责设计文件的制作和输出，确保设计质量符合印刷要求

        \n**工作业绩**：
        \n• 完成50+个品牌设计项目，客户满意度达95%以上
        \n• 设计作品多次获得行业认可，其中3个作品获得设计奖项
        \n• 协助公司建立标准化设计流程，提高工作效率30%
        \n• 培养2名设计助理，提升团队整体设计水平
        `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/06/01',
            toDate: '2023/07/31',
            toNow: false,
            isDisable: false,
            subject: 'XX文化传媒公司',
            major: '设计实习生',
            content: `
            \n**实习内容**：
            \n• 协助设计师完成日常设计任务，包括海报设计、宣传材料制作等
            \n• 学习设计软件操作技巧，提升设计效率和作品质量
            \n• 参与项目创意讨论，学习设计思维和创意方法
            \n• 协助处理客户反馈，学习与客户沟通的技巧

            \n**实习收获**：
            \n• 掌握了商业设计的基本流程和规范要求
            \n• 提升了设计软件操作技能和创意思维能力
            \n• 积累了丰富的项目经验和客户沟通经验
            \n• 获得实习优秀学员称号
            `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '专业技能',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: false,
        subject: '',
        major: '',
        content: `
        \n• **设计软件**：精通Photoshop、Illustrator、InDesign等Adobe系列软件，熟练使用Sketch、Figma等设计工具
        \n• **设计技能**：擅长品牌设计、VI设计、包装设计、广告设计、UI设计等多种设计类型
        \n• **创意思维**：具备优秀的创意思维和审美能力，能够准确把握设计趋势和客户需求
        \n• **印刷工艺**：熟悉印刷工艺和材料特性，能够确保设计作品的最佳印刷效果
        \n• **证书资质**：Adobe认证设计师、平面设计师职业资格证书
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n**创意思维强**：具备优秀的创意思维和审美能力，能够准确把握设计趋势，为客户提供独特而有价值的设计方案。

        \n**专业技能扎实**：精通各类设计软件，具备丰富的设计经验和专业技能，能够高效完成各种类型的设计项目。

        \n**沟通能力强**：善于与客户沟通，能够准确理解客户需求，提供专业的设计建议和解决方案。

        \n**学习能力强**：持续关注设计行业发展趋势，积极参加设计培训和交流活动，不断提升自己的设计水平和创意思维。
        `,
        children: []
      }
    ]
  },
  // 16、行政文员-简历模板
  {
    postTitle: '行政文员-简历模板',
    title: '行政文员简历',
    showTags: ['行政文员', '文员'], 
    id: 16,
    styleType: 'normal8Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_NYwI78fa17552631434806492.jpeg",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '行政文员',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '4k-6k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '工作年限',
          basicVal: '1 - 3年',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: 'clerk@example.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '女',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2019/09/01',
        toDate: '2023/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX职业技术学院',
        major: '文秘专业',
        content: `
        \n**专业课程**：秘书实务、办公自动化、商务礼仪、档案管理、公文写作、人力资源管理、商务英语、计算机应用基础等
        \n**荣誉奖项**：校级优秀学生、文秘技能大赛三等奖、计算机等级证书
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2023/08/01',
        toDate: '2024/06/01',
        toNow: false,
        isDisable: false,
        subject: 'XX贸易有限公司',
        major: '行政文员',
        content: `
        \n**工作职责**：
        \n• 负责公司日常行政事务处理，包括文件收发、档案管理、会议安排等
        \n• 协助人事部门进行员工考勤管理、入职离职手续办理等工作
        \n• 负责办公用品采购、库存管理，确保办公用品及时供应
        \n• 协助接待来访客户，维护公司形象
        \n• 负责公司各类文件的整理、归档和保管工作

        \n**工作业绩**：
        \n• 优化文件管理流程，将文件查找时间缩短50%，提高工作效率
        \n• 建立完善的办公用品管理制度，为公司节省办公成本15%
        \n• 协助组织公司年会、团建等活动，获得员工一致好评
        \n• 获得公司年度优秀员工称号，多次获得部门表扬
        `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2022/06/01',
            toDate: '2023/07/31',
            toNow: false,
            isDisable: false,
            subject: 'XX商贸公司',
            major: '前台文员',
            content: `
            \n**实习内容**：
            \n• 负责前台接待工作，接听电话、接待来访客户
            \n• 协助处理日常行政事务，包括文件整理、资料复印等
            \n• 学习使用办公软件，提升工作效率
            \n• 协助人事部门进行简单的招聘辅助工作

            \n**实习收获**：
            \n• 掌握了基本的行政工作流程和规范
            \n• 提升了沟通协调能力和服务意识
            \n• 熟悉了办公软件的使用技巧
            \n• 培养了良好的职业素养和工作态度
            `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '专业技能',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: false,
        subject: '',
        major: '',
        content: `
        \n• **办公软件**：熟练使用Word、Excel、PowerPoint等Office办公软件，掌握WPS等办公工具
        \n• **行政技能**：精通文件管理、档案整理、会议组织、接待礼仪等行政工作技能
        \n• **沟通协调**：具备良好的沟通协调能力，能够有效处理内外部关系
        \n• **服务意识**：具备较强的服务意识和责任心，能够主动为员工和客户提供帮助
        \n• **证书资质**：文秘职业资格证书、计算机等级证书
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n**工作认真负责**：对待工作认真细致，有较强的责任心，能够按时保质完成各项任务，注重工作细节和质量。

        \n**沟通能力强**：具备良好的沟通协调能力，能够与各部门同事保持良好的合作关系，有效处理各种工作事务。

        \n**学习能力强**：善于学习新知识和技能，能够快速适应新的工作环境和要求，不断提升自己的专业能力。

        \n**服务意识好**：具备较强的服务意识，能够主动为员工和客户提供帮助，维护公司良好形象。
        `,
        children: []
      }
    ]
  },
  // 17、前端开发-简历模板
  {
    postTitle: '前端开发-简历模板',
    title: '前端开发工程师简历',
    showTags: ['前端开发', 'Web开发'], 
    id: 17,
    styleType: 'normal3Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_NvIbwLlo17443794063422783.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '前端开发工程师',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '12k-20k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '工作年限',
          basicVal: '3 - 5年',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: 'frontend@example.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '男',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2017/09/01',
        toDate: '2021/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX理工大学',
        major: '计算机科学与技术专业',
        content: `
        \n**专业课程**：数据结构、算法设计、计算机网络、操作系统、数据库原理、软件工程、Web开发技术、JavaScript程序设计等
        \n**荣誉奖项**：校级一等奖学金、优秀毕业生、蓝桥杯程序设计大赛省级二等奖
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2021/08/01',
        toDate: '2024/06/01',
        toNow: false,
        isDisable: false,
        subject: 'XX互联网科技有限公司',
        major: '前端开发工程师',
        content: `
        \n**工作职责**：
        \n• 负责公司核心产品的前端开发工作，使用Vue.js、React等主流框架进行项目开发
        \n• 参与产品需求分析和技术方案设计，提供前端技术解决方案
        \n• 负责前端性能优化，提升用户体验和页面加载速度
        \n• 与后端开发团队协作，完成接口对接和联调工作
        \n• 参与代码审查，确保代码质量和开发规范

        \n**工作业绩**：
        \n• 主导完成公司电商平台前端重构项目，页面加载速度提升60%，用户体验显著改善
        \n• 开发了多个可复用的前端组件库，提高了团队开发效率30%
        \n• 优化了前端构建流程，将构建时间缩短50%，提升开发效率
        \n• 获得公司年度技术贡献奖，多次获得项目优秀员工称号
        `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2020/07/01',
            toDate: '2021/07/31',
            toNow: false,
            isDisable: false,
            subject: 'XX软件公司',
            major: '前端开发实习生',
            content: `
            \n**实习内容**：
            \n• 协助前端开发工程师完成日常开发任务，包括页面制作、功能实现等
            \n• 学习使用Vue.js、React等前端框架，掌握现代前端开发技术
            \n• 参与项目需求讨论，学习需求分析和方案设计
            \n• 协助进行代码测试和bug修复工作

            \n**实习收获**：
            \n• 掌握了现代前端开发技术栈和开发流程
            \n• 熟悉了团队协作和版本控制工具的使用
            \n• 提升了代码质量和编程规范意识
            \n• 获得实习优秀学员称号
            `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '专业技能',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: false,
        subject: '',
        major: '',
        content: `
        \n• **前端技术**：精通HTML5、CSS3、JavaScript，熟练使用Vue.js、React、TypeScript等现代前端技术
        \n• **开发工具**：熟练使用Webpack、Vite等构建工具，掌握Git版本控制和VS Code等开发工具
        \n• **UI框架**：熟悉Element UI、Ant Design、Bootstrap等UI组件库的使用
        \n• **性能优化**：具备前端性能优化经验，熟悉懒加载、代码分割、缓存策略等技术
        \n• **证书资质**：计算机等级证书、前端开发工程师认证
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n**技术能力强**：具备扎实的计算机基础知识和前端开发技能，能够独立完成复杂的前端项目开发工作。

        \n**学习能力强**：持续关注前端技术发展趋势，积极学习新技术，能够快速掌握和应用新的开发技术。

        \n**团队协作好**：具备良好的团队协作能力，能够与产品、设计、后端等团队有效沟通，确保项目顺利进行。

        \n**责任心强**：对待工作认真负责，注重代码质量和用户体验，能够主动承担技术难题和项目责任。
        `,
        children: []
      }
    ]
  },
  // 18、电商运营-简历模板
  {
    postTitle: '电商运营-简历模板',
    title: '电商运营专员简历',
    showTags: ['电商运营', '运营'], 
    id: 18,
    styleType: 'normal7Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_NKZTAtBc17552634954263592.jpeg",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '电商运营专员',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '8k-15k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '工作年限',
          basicVal: '2 - 4年',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: 'ecommerce@example.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '女',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2018/09/01',
        toDate: '2022/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX商学院',
        major: '电子商务专业',
        content: `
        \n**专业课程**：电子商务概论、网络营销、消费者行为学、供应链管理、数据分析、商务英语、市场营销、管理学原理等
        \n**荣誉奖项**：校级奖学金、电子商务创新大赛三等奖、优秀毕业生
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2022/08/01',
        toDate: '2024/06/01',
        toNow: false,
        isDisable: false,
        subject: 'XX电商科技有限公司',
        major: '电商运营专员',
        content: `
        \n**工作职责**：
        \n• 负责天猫、京东等主流电商平台的店铺运营，包括商品上架、价格管理、活动策划等
        \n• 制定并执行店铺营销策略，通过数据分析优化商品展示和销售转化
        \n• 负责店铺日常维护，包括客服管理、订单处理、售后服务协调等
        \n• 与供应商、物流商等合作伙伴协调，确保商品供应和配送效率
        \n• 监控竞品动态，分析市场趋势，制定相应的运营策略

        \n**工作业绩**：
        \n• 负责的店铺月销售额从50万提升至120万，同比增长140%
        \n• 优化商品详情页，转化率提升35%，客单价提升20%
        \n• 策划的"双11"活动销售额突破200万，获得公司年度优秀员工
        \n• 建立完善的客户服务体系，客户满意度达到95%以上
        `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2021/07/01',
            toDate: '2022/07/31',
            toNow: false,
            isDisable: false,
            subject: 'XX贸易公司',
            major: '电商运营实习生',
            content: `
            \n**实习内容**：
            \n• 协助运营专员进行商品上架、价格调整等基础运营工作
            \n• 学习使用电商后台管理系统，熟悉各平台运营规则
            \n• 参与客服工作，处理客户咨询和投诉
            \n• 协助进行数据统计和分析工作

            \n**实习收获**：
            \n• 掌握了电商运营的基本流程和操作技巧
            \n• 熟悉了主流电商平台的运营规则和后台操作
            \n• 提升了客户服务意识和沟通能力
            \n• 培养了数据分析和问题解决能力
            `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '专业技能',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: false,
        subject: '',
        major: '',
        content: `
        \n• **电商平台**：熟练操作天猫、京东、拼多多等主流电商平台，熟悉各平台运营规则和后台操作
        \n• **数据分析**：熟练使用Excel、PowerBI等工具进行数据分析，能够通过数据指导运营决策
        \n• **营销策划**：具备活动策划和营销推广能力，能够制定有效的促销方案
        \n• **客户服务**：具备良好的客户服务意识和沟通能力，能够有效处理客户问题
        \n• **证书资质**：电子商务师证书、网络营销师证书
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n**数据驱动思维**：具备较强的数据分析能力，能够通过数据洞察市场趋势和用户需求，制定有效的运营策略。

        \n**执行力强**：工作认真负责，能够高效执行各项运营任务，具备较强的项目管理和时间管理能力。

        \n**学习能力强**：持续关注电商行业发展趋势，积极学习新的运营工具和方法，能够快速适应市场变化。

        \n**团队协作好**：具备良好的沟通协调能力，能够与产品、设计、客服等团队有效协作，确保项目顺利进行。
        `,
        children: []
      }
    ]
  },
  // 19、商务司机-简历模板
  {
    postTitle: '商务司机-简历模板',
    title: '商务司机简历',
    showTags: ['商务司机', '司机'], 
    id: 19,
    styleType: 'normal1Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_7KERunDM17443793409848382.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '商务司机',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '6k-10k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '工作年限',
          basicVal: '3 - 6年',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: 'driver@example.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '男',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2015/09/01',
        toDate: '2018/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX职业技术学院',
        major: '汽车运用技术专业',
        content: `
        \n**专业课程**：汽车构造、汽车维修、汽车驾驶技术、交通安全法规、汽车保险理赔、汽车营销等
        \n**荣誉奖项**：校级优秀学生、汽车维修技能大赛二等奖、优秀毕业生
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2018/08/01',
        toDate: '2024/06/01',
        toNow: false,
        isDisable: false,
        subject: 'XX贸易有限公司',
        major: '商务司机',
        content: `
        \n**工作职责**：
        \n• 负责公司高管和重要客户的商务接送服务，确保安全、准时、舒适
        \n• 负责公司车辆的日常维护保养，包括清洁、检查、维修等
        \n• 协助处理车辆相关事务，包括保险、年检、违章处理等
        \n• 参与公司重要活动的车辆保障工作，如会议、接待、商务考察等
        \n• 严格遵守交通法规，确保行车安全，维护公司形象

        \n**工作业绩**：
        \n• 连续5年无重大交通事故，安全行驶里程超过20万公里
        \n• 获得公司年度安全驾驶奖，多次获得客户好评和表扬
        \n• 协助公司完成多次重要商务接待任务，为公司业务发展做出贡献
        \n• 建立完善的车辆维护记录，为公司节省维修成本
        `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2017/06/01',
            toDate: '2018/07/31',
            toNow: false,
            isDisable: false,
            subject: 'XX物流公司',
            major: '货车司机',
            content: `
            \n**实习内容**：
            \n• 负责公司货物的运输配送工作，确保货物安全准时送达
            \n• 学习车辆维护保养知识，掌握基本的故障排除技能
            \n• 熟悉物流配送流程，提升驾驶技能和路况判断能力
            \n• 协助进行货物装卸和运输单据处理工作

            \n**实习收获**：
            \n• 积累了丰富的驾驶经验，提升了驾驶技能和安全意识
            \n• 熟悉了车辆维护保养的基本知识和方法
            \n• 培养了良好的时间观念和责任心
            \n• 获得了B2驾驶证和从业资格证
            `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '专业技能',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: false,
        subject: '',
        major: '',
        content: `
        \n• **驾驶技能**：具备A1、A2、B1、B2、C1、C2等各类驾驶证，驾驶技术娴熟，安全驾驶经验丰富
        \n• **车辆维护**：熟悉各类车辆的构造和性能，具备基本的故障诊断和维修能力
        \n• **路线规划**：熟悉城市道路和高速公路，能够合理规划行车路线，提高行驶效率
        \n• **服务意识**：具备良好的服务意识和沟通能力，能够为客户提供优质的商务用车服务
        \n• **证书资质**：A1驾驶证、道路运输从业资格证、汽车维修工证书
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n**安全意识强**：具备强烈的安全驾驶意识，严格遵守交通法规，确保行车安全，从未发生重大交通事故。

        \n**责任心强**：工作认真负责，能够按时完成各项驾驶任务，注重车辆维护保养，确保车辆处于良好状态。

        \n**服务意识好**：具备良好的服务意识和沟通能力，能够为客户提供专业、舒适的商务用车服务。

        \n**学习能力强**：持续学习新的驾驶技术和车辆知识，不断提升自己的专业能力和服务水平。
        `,
        children: []
      }
    ]
  },
  // 20、投资经理-简历模板
  {
    postTitle: '投资经理-简历模板',
    title: '投资经理简历',
    showTags: ['投资经理', '投资顾问'], 
    id: 20,
    styleType: 'normal9Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_SvGBRvQb1755263155483416.jpeg",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '投资经理',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '20k-35k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '工作年限',
          basicVal: '5 - 8年',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: 'investment@example.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '男',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2013/09/01',
        toDate: '2017/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX财经大学',
        major: '金融学专业',
        content: `
        \n**专业课程**：投资学、金融市场学、证券投资分析、公司金融、风险管理、金融工程、计量经济学、国际金融等
        \n**荣誉奖项**：校级一等奖学金、优秀毕业生、CFA一级证书、证券从业资格证
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2017/08/01',
        toDate: '2024/06/01',
        toNow: false,
        isDisable: false,
        subject: 'XX投资管理有限公司',
        major: '投资经理',
        content: `
        \n**工作职责**：
        \n• 负责公司投资组合的管理和优化，制定投资策略和资产配置方案
        \n• 进行市场研究和行业分析，识别投资机会和风险，提供投资建议
        \n• 负责项目尽职调查、投资决策和投后管理工作
        \n• 与客户沟通，了解投资需求，提供个性化的投资解决方案
        \n• 监控投资组合表现，定期进行风险评估和收益分析

        \n**工作业绩**：
        \n• 管理的投资组合年化收益率达到15%，超过市场平均水平8个百分点
        \n• 成功投资了5个优质项目，其中3个项目已成功退出，投资回报率超过200%
        \n• 建立了完善的投资分析模型，提高了投资决策的准确性和效率
        \n• 获得公司年度优秀投资经理称号，多次获得客户高度认可
        `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2016/07/01',
            toDate: '2017/07/31',
            toNow: false,
            isDisable: false,
            subject: 'XX证券公司',
            major: '投资顾问实习生',
            content: `
            \n**实习内容**：
            \n• 协助投资顾问进行客户投资需求分析和投资方案设计
            \n• 学习使用金融分析工具和软件，掌握基本的投资分析方法
            \n• 参与市场研究和行业分析工作，撰写投资分析报告
            \n• 协助进行客户关系维护和投资咨询服务

            \n**实习收获**：
            \n• 掌握了基本的投资分析方法和工具使用技巧
            \n• 熟悉了证券市场和投资产品的基本知识
            \n• 提升了客户沟通和投资建议能力
            \n• 获得了证券从业资格证和基金从业资格证
            `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '专业技能',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: false,
        subject: '',
        major: '',
        content: `
        \n• **投资分析**：精通财务分析、估值建模、风险评估等投资分析方法，熟练使用Bloomberg、Wind等金融终端
        \n• **投资产品**：熟悉股票、债券、基金、期货、期权等各类投资产品的特点和风险收益特征
        \n• **市场研究**：具备较强的市场研究和行业分析能力，能够识别投资机会和风险
        \n• **客户服务**：具备良好的客户沟通能力，能够为客户提供专业的投资建议和解决方案
        \n• **证书资质**：CFA三级证书、证券从业资格证、基金从业资格证、期货从业资格证
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n**专业能力强**：具备扎实的金融理论基础和丰富的投资实践经验，能够独立完成复杂的投资分析和决策工作。

        \n**风险意识强**：具备强烈的风险控制意识，能够准确识别和评估投资风险，制定有效的风险控制措施。

        \n**学习能力强**：持续关注金融市场动态和投资理论发展，积极学习新的投资工具和方法，保持专业竞争力。

        \n**沟通能力强**：具备良好的客户沟通和团队协作能力，能够与客户、同事和合作伙伴有效沟通，确保投资目标的实现。
        `,
        children: []
      }
    ]
  },
  // 21、数据分析师-简历模板
  {
    postTitle: '数据分析师-简历模板',
    title: '数据分析师简历',
    showTags: ['数据分析师', '数据分析'], 
    id: 21,
    styleType: 'normal3Style',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_RMtxCRcr17443792841851021.png",
    basicInfo: {
      title: '基础信息',
      cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
      tag: '基础模版',
      edit: false,
      isAppear: true,
      avatar: ikun,
      basicInfos: [
        {
          id: uuidv4(),
          basicKey: '姓名',
          basicVal: '你的名字',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '求职意向',
          basicVal: '数据分析师',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '期望月薪',
          basicVal: '15k-25k',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '工作年限',
          basicVal: '3 - 6年',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '电话',
          basicVal: '12312344321',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '邮箱',
          basicVal: 'data@example.com',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        },
        {
          id: uuidv4(),
          basicKey: '性别',
          basicVal: '女',
          placeholderKey: '属性',
          placeholderVal: '属性值'
        }
      ]
    },
    otherInfos: [
      {
        id: uuidv4(),
        sort: 1,
        title: '教育经历',
        edit: false,
        isAppear: true,
        fromDate: '2016/09/01',
        toDate: '2020/07/01',
        toNow: false,
        isDisable: false,
        subject: 'XX大学',
        major: '统计学专业',
        content: `
        \n**专业课程**：概率论与数理统计、回归分析、时间序列分析、多元统计分析、数据挖掘、机器学习、R语言、Python编程等
        \n**荣誉奖项**：校级一等奖学金、优秀毕业生、数学建模竞赛省级一等奖、统计建模大赛全国三等奖
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 3,
        title: '工作经历',
        edit: false,
        isAppear: true,
        fromDate: '2020/08/01',
        toDate: '2024/06/01',
        toNow: false,
        isDisable: false,
        subject: 'XX互联网科技有限公司',
        major: '数据分析师',
        content: `
        \n**工作职责**：
        \n• 负责公司核心业务数据的收集、清洗、分析和挖掘，为业务决策提供数据支持
        \n• 构建数据分析模型，进行用户行为分析、产品效果评估和业务趋势预测
        \n• 设计并维护数据报表和可视化仪表板，定期输出数据分析报告
        \n• 与产品、运营、技术等团队协作，提供数据驱动的业务优化建议
        \n• 参与A/B测试设计，分析测试结果，评估产品改进效果

        \n**工作业绩**：
        \n• 建立了用户流失预警模型，提前识别流失风险用户，用户留存率提升25%
        \n• 优化了推荐算法，通过数据分析改进推荐策略，用户转化率提升30%
        \n• 建立了完善的数据监控体系，将数据异常发现时间从小时级缩短到分钟级
        \n• 获得公司年度数据分析贡献奖，多次获得业务部门高度认可
        `,
        children: [
          {
            id: uuidv4(),
            sort: 1,
            edit: false,
            isAppear: true,
            isLeaf: true,
            fromDate: '2019/07/01',
            toDate: '2020/07/31',
            toNow: false,
            isDisable: false,
            subject: 'XX咨询公司',
            major: '数据分析实习生',
            content: `
            \n**实习内容**：
            \n• 协助数据分析师进行数据收集、清洗和基础分析工作
            \n• 学习使用SQL、Python、R等数据分析工具和编程语言
            \n• 参与客户项目的数据分析工作，撰写分析报告
            \n• 协助进行数据可视化和报告制作工作

            \n**实习收获**：
            \n• 掌握了基本的数据分析方法和工具使用技巧
            \n• 熟悉了商业数据分析的流程和规范
            \n• 提升了数据可视化和报告撰写能力
            \n• 培养了数据思维和业务理解能力
            `
          }
        ]
      },
      {
        id: uuidv4(),
        sort: 4,
        title: '专业技能',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: false,
        subject: '',
        major: '',
        content: `
        \n• **编程语言**：精通Python、R、SQL等数据分析编程语言，熟练使用Pandas、NumPy、Scikit-learn等库
        \n• **数据分析工具**：熟练使用Excel、PowerBI、Tableau等数据分析工具，掌握数据可视化技术
        \n• **统计方法**：精通描述性统计、推断统计、回归分析、时间序列分析等统计方法
        \n• **机器学习**：熟悉监督学习、无监督学习算法，具备模型构建和评估能力
        \n• **证书资质**：数据分析师证书、Python数据分析师认证、统计师证书
        `,
        children: []
      },
      {
        id: uuidv4(),
        sort: 5,
        title: '个人评价',
        edit: false,
        isAppear: true,
        fromDate: '',
        toDate: '',
        toNow: false,
        isDisable: true,
        subject: '',
        major: '',
        content: `
        \n**数据思维强**：具备敏锐的数据洞察力，能够从复杂数据中发现有价值的业务洞察，为决策提供科学依据。

        \n**技术能力强**：具备扎实的统计学基础和编程技能，能够独立完成复杂的数据分析项目，解决业务问题。

        \n**学习能力强**：持续关注数据分析技术发展趋势，积极学习新的分析方法和工具，保持技术竞争力。

        \n**沟通能力强**：具备良好的业务理解能力和沟通表达能力，能够将复杂的数据分析结果转化为业务人员易于理解的语言。
        `,
        children: []
      }
    ]
  },
]
